import { AgmInfoWindow, AgmMap } from '@agm/core';
import { HttpClient } from '@angular/common/http';
import { Component, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { Step2 } from 'src/main/webapp/assets/models/iter.model';
import { RestTmtService } from '../../rest-tmt.service';

/** Configurazione mappa per tenant (`tenant.json` → `mapSettings`). Chiavi tutte opzionali. */
interface MapSettings {
  lineColor?: string;
  mapStyles?: google.maps.MapTypeStyle[];
  mapStyleUrl?: string;
  pinColor?: string;
}

// tslint:disable-next-line:completed-docs
@Component({
  selector: 'app-map',
  styleUrls: ['./map.component.scss'],
  templateUrl: './map.component.html'
})
export class MapComponent implements OnInit {
  public lineColor = 'red';
  // @ts-ignore
  @ViewChild('mapElement') public mapElement: AgmMap;
  public markerIcon: string | undefined;
  public pinColor = 'red';
  public previous: AgmInfoWindow | undefined;

  @Input() public steps: Step2[] = [];
  public styles: google.maps.MapTypeStyle[] = [];

  public visibleSteps: Step2[] = [];

  constructor(
    private readonly restTmt: RestTmtService,
    private readonly http: HttpClient
  ) {}

  public ngOnInit(): void {
    this.applyMapSettings();

    this.visibleSteps = this.steps.filter(step =>
      step.latitude &&
      step.longitude &&
      step.latitude.trim() !== '' &&
      step.longitude.trim() !== ''
    );
  }

  /* come da call con mina, questo è un componente che va scritto proprio così,
   * quindi è più opportuno disabilitare il warning
   */
  // tslint:disable-next-line: no-unsafe-any
  @HostListener('window:resize') public onResize() {
    this.mapElement.triggerResize();
  }

  public clickedMarker(infowindow: AgmInfoWindow) {
    if (this.previous) {
      this.previous.close();
    }
    this.previous = infowindow;
  }

  public close_window() {
    if (this.previous !== undefined) {
      this.previous.close();
    }
  }

  /**
   * Applica la configurazione mappa del tenant (tenant.json → mapSettings).
   * Assente `mapSettings` ⇒ nessuna modifica: linea rossa, nessuno stile, pin di default.
   */
  private applyMapSettings(): void {
    // getClient() restituisce il profilo tenant (tipizzato `any`); la chiave è opzionale.
    // tslint:disable-next-line: no-unsafe-any
    const settings = this.restTmt.getClient()?.mapSettings as MapSettings | undefined;
    if (!settings) {
      return;
    }

    if (settings.lineColor) {
      this.lineColor = settings.lineColor;
    }

    if (settings.pinColor) {
      this.pinColor = settings.pinColor;
      this.markerIcon = this.buildMarkerIcon(this.pinColor);
    }

    if (Array.isArray(settings.mapStyles) && settings.mapStyles.length > 0) {
      this.styles = settings.mapStyles;
    } else if (settings.mapStyleUrl) {
      this.loadMapStyle(settings.mapStyleUrl);
    }
  }

  private loadMapStyle(url: string): void {
    this.http.get<google.maps.MapTypeStyle[]>(url).subscribe(
      styles => this.styles = Array.isArray(styles) ? styles : [],
      () => this.styles = []
    );
  }

  private buildMarkerIcon(color: string): string {
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="28" height="40" viewBox="0 0 28 40">` +
      `<path fill="${color}" stroke="#ffffff" stroke-width="1.5" ` +
      `d="M14 0C6.27 0 0 6.27 0 14c0 10.5 14 26 14 26s14-15.5 14-26C28 6.27 21.73 0 14 0z"/></svg>`;

    return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
  }
}
